// ===========================================
// BUSTED! BLACKJACK - SHARED CONSTANTS
// ===========================================
// ----- Game Rules -----
export const GAME_CONSTANTS = {
    // Deck configuration
    DECK_COUNT: 6,
    CARDS_PER_DECK: 52,
    RESHUFFLE_THRESHOLD: 75, // Reshuffle when fewer than 75 cards remain
    // Table limits
    MIN_BET: 1,
    MAX_BET: 500,
    MAX_PLAYERS: 7,
    MAX_SPECTATORS: 50, // Soft cap with alerts
    // Timing
    TURN_TIMER_SECONDS: 30,
    DISCONNECT_TOLERANCE_SECONDS: 30,
    BETTING_PHASE_SECONDS: 30,
    // Splits
    MAX_SPLIT_HANDS: 4,
    // Payouts (standard tables)
    BLACKJACK_PAYOUT: 1.5, // 3:2
    STANDARD_PAYOUT: 1, // 1:1
    // Payouts (sponsored tables)
    SPONSORED_BLACKJACK_PAYOUT: 2, // 2:1
    SPONSORED_PAYOUT_BOOST: 0.25, // 25% extra on wins
    // Dealer rules
    DEALER_STAND_VALUE: 17, // Stands on all 17s
};
// ----- Economy -----
export const ECONOMY_CONSTANTS = {
    // Starting balance
    STARTING_CHIPS: 2_500,
    DAILY_FREE_CHIPS: 1_000,
    CHIP_SOFT_CAP: 1_000_000, // Hide refill above this
    // Chip purchases
    CHIPS_PER_DOLLAR: 5_000, // $1 = 5,000 chips
    // Username changes
    FIRST_USERNAME_CHANGE_FREE: true,
    USERNAME_CHANGE_COST: 1_000,
    // Button power
    BUTTON_POWER_COST_PERCENT: 0.01, // 1% of balance
};
// ----- Sponsorship -----
export const SPONSOR_CONSTANTS = {
    DAILY_RATE: 5,
    WEEKLY_RATE: 30,
    MONTHLY_RATE: 100,
};
// ----- Rate Limits -----
export const RATE_LIMITS = {
    TABLE_CREATION: { count: 5, windowSeconds: 3600 }, // 5/hour
    CHAT_MESSAGES: { count: 10, windowSeconds: 60 }, // 10/min
    JOIN_LEAVE_TABLE: { count: 10, windowSeconds: 60 }, // 10/min
    PAYPAL_DONATIONS: { count: 5, windowSeconds: 600 }, // 5/10min
    ACCOUNT_CREATION_PER_IP: { count: 3, windowSeconds: 86400 }, // 3/day
};
// ----- Session -----
export const SESSION_CONSTANTS = {
    JWT_EXPIRY_DAYS: 7,
    COOKIE_NAME: 'cg_session',
    REFRESH_COOKIE_NAME: 'cg_refresh',
};
// ----- Terms of Service -----
export const TOS_CONSTANTS = {
    CURRENT_VERSION: '1.0',
};
// ----- Card Values -----
export const CARD_SUITS = ['hearts', 'diamonds', 'clubs', 'spades'];
export const CARD_RANKS = ['A', '2', '3', '4', '5', '6', '7', '8', '9', '10', 'J', 'Q', 'K'];
export const CARD_VALUES = {
    'A': [1, 11],
    '2': [2],
    '3': [3],
    '4': [4],
    '5': [5],
    '6': [6],
    '7': [7],
    '8': [8],
    '9': [9],
    '10': [10],
    'J': [10],
    'Q': [10],
    'K': [10],
};
//# sourceMappingURL=constants.js.map